import {Box} from '@mui/material'
import PropTypes from 'prop-types'
import {StyledSectionTitle, StyledTextContent} from '../../AdminPanelStyling'
import MultiSelectDropdownComponent from '../../common/MulitSelectDropdown/MultiSelectDropdownComponent'

const Workforces = ({workforces, selectedData, setSelectedData}) => {
  const renderDropdown = () => {
    return (
      <MultiSelectDropdownComponent
        selectAllTitle='Select All'
        dropDownTitle='Select Workforce'
        inputAndPreviewTitle='Workforces'
        dropDownModifiedTitle='Selected Workforces'
        dropDownData={workforces}
        val={selectedData}
        setVal={setSelectedData}
        isCompleted={false}
        conditionalProps={{isOptionEqualToValue: (option, value) => option.id === value.id}}
      />
    )
  }

  return (
    <Box tabIndex={0} aria-label='Workforces'>
      <StyledSectionTitle variant='h5'>{'What Workforces do you want Available?'}</StyledSectionTitle>
      <StyledTextContent>Workforce displays who is eligible for jobs related to recruiment.</StyledTextContent>
      {renderDropdown()}
    </Box>
  )
}

Workforces.propTypes = {
  workforces: PropTypes.array.isRequired,
  selectedData: PropTypes.array.isRequired,
  setSelectedData: PropTypes.func.isRequired
}

export default Workforces

/* Function Descriptions:
   Workforces is a React functional component that renders a section for selecting available workforces.
    It uses a multi-select dropdown to allow users to choose from a list of workforces.
    The component accepts three props:
    - workforces: An array of workforce objects to be displayed in the dropdown.
    - selectedData: An array of currently selected workforce objects.
    - setSelectedData: A function to update the selected workforce data.
    The component renders a title and description, followed by the multi-select dropdown for user interaction.
*/
